import { useTranslation } from "react-i18next";
import { cn } from "@nexus/ui";
import type { PreflightPlatformCode } from "@nexus/contracts";
import { PlatformIcon } from "../PlatformIcon/PlatformIcon";

export interface PlatformLabelProps {
  platform: PreflightPlatformCode;
  className?: string;
}

/** A platform's brand mark followed by its localized name — the paired form used
 *  in pickers, tabs, and table cells. */
export function PlatformLabel({ platform, className }: PlatformLabelProps) {
  const { t } = useTranslation();

  return (
    <span className={cn("inline-flex min-w-0 items-center gap-1.5", className)}>
      <PlatformIcon platform={platform} />
      <span className="truncate">{t(`preflight.platform.${platform}`)}</span>
    </span>
  );
}
